import {post, postfile, downFile} from './http'
const baseUrl = '/api/admin/mkcenter/distribute/statistics'

// 推广员列表 /api/admin/mkcenter/distribute/statistics/promoterList
export const extensionAgentList = v => post(`${baseUrl}/promoterList`, v.data, v.success, v.error)
// 推广员审核通过 拒绝或清退
export const auditPassRejectReturn = v => post(`${baseUrl}/promoterAudit`, v.data, v.success, v.error)
// 推广员等级修改
export const editGrade = v => post(`${baseUrl}/updatePromoterLevel`, v.data, v.success, v.error)
// 审核列表
export const auditList = v => post(`${baseUrl}/promoterAuditList`, v.data, v.success, v.error)
// 推广记录表
export const extensionRecode = v => post(`${baseUrl}/pormoterRecord`, v.data, v.success, v.error)
// 导出excel 推广记录表
export const exportExtensionRecode = v => downFile(`${baseUrl}/exportRecord`, v.data, v.success, v.error)
// 买家绑定列表
export const buyBindingList = v => post(`${baseUrl}/clientCustomerBindList`, v.data, v.success, v.error)
// 业绩统计列表
export const statisticalList = v => post(`${baseUrl}/statisticalList`, v.data, v.success, v.error)
// 推广员详情
export const extensionAgentMsg = v => post(`${baseUrl}/promoterInfo`, v.data, v.success, v.error)
// 客户绑定或者解绑列表
export const bindUnbindList = v => post(`${baseUrl}/promoterBindOrUnbind`, v.data, v.success, v.error)
// 下级列表
export const subordinateList = v => post(`${baseUrl}/pormoterSubordinateList`, v.data, v.success, v.error)
